import { Id, QueryParams } from "PFTypes";

export const skillsKeys = {
  all: () => ["skills"],
  single: (id: Id) => [...skillsKeys.all(), id.toString()],
  discovered: () => [...skillsKeys.all(), "discovered"],
  framework: (params: QueryParams = {}) => [...skillsKeys.all(), "framework", params]
};
